/**
 * Standalone Integrations App Component
 *
 * This component loads the Integrations App.tsx directly when running
 * in standalone mode (not as MFE). It works within the ispm router context
 * and uses the existing providers from the ispm app.
 *
 * MFE logic remains completely untouched - this is only used when
 * VITE_INTEGRATIONS_STANDALONE=true or when MFE config is not available.
 */
import { ThemeProvider } from "@repo/mfe-core";
import App from "../../../../integrations/src/App";

/**
 * Wrapper component that renders the Integrations App in standalone mode.
 *
 * The App component automatically detects standalone mode by checking
 * the current router pathname and adjusts navigation accordingly.
 *
 * ThemeProvider is required because the Integrations App's components call
 * `useTheme` from `@repo/mfe-core`. In MFE mode `AppWrapper.tsx` supplies it;
 * in this direct-import standalone path we supply it here.
 */
export function IntegrationsApp() {
  return (
    <ThemeProvider>
      <App />
    </ThemeProvider>
  );
}
